import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Tag, Loader, Empty } from "@/components/kit";
import { ScrollText, ArrowRight } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data.logs)).catch(() => setLogs(false)); }, []);

  if (logs === null) return <Loader label="Loading audit trail" />;
  if (!logs) return <Empty label="Could not load logs" />;

  return (
    <div className="fade-up">
      <PageHeader overline="Governance & compliance" title="Audit Logs"
        subtitle="Every verification, assignment, payment and configuration change — fully traceable." testid="audit-logs-page" />

      {logs.length === 0 ? <Empty label="No audit events yet" /> : (
        <div className="krida-card p-2">
          {logs.map((l) => (
            <div key={l.id} className="flex items-center gap-4 p-4 border-b border-white/5 last:border-0" data-testid={`audit-${l.id}`}>
              <div className="w-9 h-9 rounded-lg bg-krida-crimson/10 grid place-items-center flex-shrink-0"><ScrollText className="w-4 h-4 text-krida-crimson" /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-sm">{l.action}</span>
                  <Tag>{l.entity}</Tag>
                </div>
                <div className="text-xs text-slate-500 mt-1 flex items-center gap-2 flex-wrap">
                  <span>{l.user}</span>
                  {(l.previous || l.new) && (
                    <span className="flex items-center gap-1.5 font-mono">
                      {l.previous && <span className="text-slate-600">{l.previous}</span>}
                      <ArrowRight className="w-3 h-3" />
                      <span className="text-krida-emerald">{l.new}</span>
                    </span>
                  )}
                </div>
              </div>
              <div className="text-xs text-slate-600 font-mono flex-shrink-0">{new Date(l.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
